const BASE_URL = 'https://api.dedabit.co/v1/'
const SOCKET_URL = 'https://api.dedabit.co/'

export { BASE_URL, SOCKET_URL }
